<template>
  <TextField
    inputId="fp-system-key"
    name="freedompay.badge_pay_system_key"
    :label="translate(`${LOCALE_PREFIX}.form.freedomPay.systemKey`)"
    :placeholder="translate(`${LOCALE_PREFIX}.form.freedomPay.systemKeyPlaceholder`)"
    :required="editCashlessPay"
    :disabled="!editCashlessPay"
  />
</template>

<script setup lang="ts">
import { useTranslation } from '@centric-os/helpers';
import { storeToRefs } from 'pinia';
import { SitesLocalePrefix } from '../../../../../../../enums';
import { useFinancialConfigStore } from '../../../../../../../routes';

// Set localization
const { translate } = useTranslation();
const LOCALE_PREFIX = SitesLocalePrefix.SITE_CASHLESS_PAYMENT;

// Set financial config store
const fConfigStore = useFinancialConfigStore();
const { editCashlessPay } = storeToRefs(fConfigStore);
</script>
